import { combineReducers } from 'redux';
import usersSliceReducer from './users/usersSlice';
import storesSliceReducer from './stores/storesSlice';

const adminStateReducer = combineReducers({
    users: usersSliceReducer,
    stores: storesSliceReducer,
});

export default adminStateReducer;
